module.exports = __webpack_public_path__ + "media/images/purchase-step-2-ab1a7096fb1a86e39c8bc950fa05f7c5.png";